export const multishiftjobinfoSelector = state => state.multishiftjobinfo;